import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {resetAllFilters, setProposalListFilterParams} from "../../../../../business/redux/reducers/filter/actions";
import {closeModal} from "../../../../../business/redux/reducers/modal/actions";
import {Badge, Box, Button, Stack, Typography} from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {getProposalList} from "../../../../../business/redux/reducers/proposalReducer/actions";
import {ProposalFilterTabs} from "./proposalFilterTabs";


export const ProposalListFilterContent = () => {

    const dispatch = useDispatch();

    const {proposalListFilterParams} = useSelector(s => s.filters);

    const filterCount = Object.keys(proposalListFilterParams)
        .reduce((acc, curr) => {
            return Array.isArray(proposalListFilterParams[curr])
                ? acc + Number(!!proposalListFilterParams[curr].length)
                : acc + Number(!!proposalListFilterParams[curr])
        }, 0);

    return (
        <>
            <Box className="modal-title" sx={{ p: 3}} direction="row" display="flex" justifyContent="space-between">
                <Badge badgeContent={filterCount} color="primary" sx={{mr:2}} className="count_shadow">
                    <Typography  variant="h1" component="div" fontWeight="700" color="#2B3033">Filters</Typography>
                </Badge>
                <Button
                    variant="outlined"
                    color="error"
                    className="remove_all_filters"
                    sx={{py: 0}}
                    startIcon={<HighlightOffIcon/>}
                    onClick={() => {
                        dispatch(resetAllFilters())
                        dispatch(closeModal())
                        dispatch(getProposalList({filterFormData: {}}))
                    }}
                >
                    Remove All Filters
                </Button>
            </Box>

            <ProposalFilterTabs/>

            <Stack className="modal-footer" sx={{ py:'10px',px: 2}} display="flex" direction="row" justifyContent="space-between">
                <Button onClick={() => dispatch(closeModal())} variant="contained" className="cancle_modal_btn">Cancel</Button>
                <Button onClick={() => {
                    dispatch(closeModal()).then(r => r);
                    dispatch(getProposalList({filterFormData: proposalListFilterParams}))
                }} variant="contained" className="view_results_btn active">View Results</Button>
            </Stack>
        </>
    )
}
